import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import BubbleContent from '../content/bubble_content';
import RedactedItem from 'components/customer/conversation_history/conversation_items_v2/redacted_item';
import ConversationItem from 'models/conversation_item';

export default function ChatTemplatedCardContent({ className, item, status }) {
  return (
    <BubbleContent
      className={classnames('chatItem-content flexible-card', className)}
      data-aid={`chatItem-content-${item.id}`}
      item={item}
      status={status}
    >
      {renderBody(item)}
    </BubbleContent>
  );
}

function renderBody(item) {
  if (item.content.isRedacted) {
    return <RedactedItem />;
  }

  const messageData = item.content.messageData;
  return (
    <>
      <pre className="flexible-card-template">{messageData.template}</pre>
      <pre className="flexible-card-data">{JSON.stringify(messageData.data)}</pre>
    </>
  );
}

ChatTemplatedCardContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
};
